const EndPoints = {
  adminLogin: 'admin/login',
  changePassword: 'admin/changePassword',
  getLibraryCategory: 'admin/getLibraryCategory',
  addLibraryCategory: 'admin/addLibraryCategory',
  updateLibraryCategory: 'admin/updateLibraryCategory',
  deleteLibraryCategory: 'admin/deleteLibraryCategory',
  getLibraryBook: 'admin/getBooks',
  addLibraryBook: 'admin/addBook',
  updateLibraryBook: 'admin/updateBook',
  deleteLibraryBook: 'admin/deleteBook',
  uploadImage: 'admin/uploadImage',
  getBusinessCategory: 'admin/getBusinessCategory',
  addBusinessCategory: 'admin/addBusinessCategory',
  updateBusinessCategory: 'admin/updateBusinessCategory',
  deleteBusinessCategory: 'admin/deleteBusinessCategory',
  getBusinssList: 'admin/getBusinessList',
  addBusiness: 'admin/addBusinessDetails',
  updateBusiness: 'admin/updateBusinessDetails',
  uploadBusinessImage: 'admin/uploadBusinessImage',
  deleteBusinessImage: 'admin/deleteBusinessImage',
  getUserProfile: 'admin/getUserDetails',
  getFeedbackList: 'admin/getFeedbackList',
  getDonationList: 'admin/getDonationList',
  updateDonationType: 'admin/updateDonationType',
  addDonationType: 'admin/addDonationType',
  getDonationType: 'admin/getDonationTypeList',
  deleteDonationType: 'admin/deleteDonationType',
  changeDonationTypeStatus: 'admin/changeDonationTypeStatus',
  changeFeedbackStatus: 'admin/changeFeedbackStatus',
  deleteFeedback: 'admin/deleteFeedback',
  getUserList: 'admin/getUserList',
  changeUserStatus: 'admin/changeUserStatus',
  changeUserMemberType: 'admin/changeUserMemberType',
  approveUser: 'admin/approveUser',
  deleteUser: 'admin/deleteUser',
  getGeneralSettings: 'admin/getGeneralSettings',
  updateLiveProgram: 'admin/saveLiveProgram',
  getAnnouncementList: 'admin/getAnnouncementList',
  addAnnouncement: 'admin/addAnnouncement',
  updateAnnouncement: 'admin/updateAnnouncement',
  deleteAnnouncement: 'admin/deleteAnnouncement',
  getSubAdmin: 'admin/getSubAdmin',
  AddSubAdmin: 'admin/createSubAdmin',
  deleteSubAdmin: 'admin/deleteSubAdmin',
  updateSubAdmin: 'admin/updateSubAdmin',
  getAdminDetail: 'admin/getAdminDetail',
  getProgramList: 'admin/getProgramList',
  addProgram: 'admin/addProgram',
  updateProgram: 'admin/updateProgram',
  deleteProgram: 'admin/deleteProgram',
  syncYoutubeVideos: 'admin/syncYoutubeVideos',
  getTeamMember: 'admin/getMemberList',
  addTeamMember: 'admin/addMember',
  updateTeamMember: 'admin/updateMember',
  deleteTeamMember: 'admin/deleteMember',
  getDayAdjustmentList: 'admin/getDayAdjustmentList',
  addDayAdjustment: 'admin/addDayAdjustment',
  updateDayAdjustment: 'admin/updateDayAdjustment',
  deleteDayAdjustment: 'admin/deleteDayAdjustment',
  getCalendarDateList: 'admin/getCalendarDateList',
  addCalendarDate: 'admin/addCalendarDate',
  updateCalendarDate: 'admin/updateCalendarDate',
  deleteCalendarDate: 'admin/deleteCalendarDate',
  deleteBusinessDetails: 'admin/deleteBusinessDetails',
  enableFitra: 'admin/enableFitra',
  getHijriDate: 'admin/getHijriDate',
  updateHijriDate: 'admin/updateHijriDate',
  addHijriDate: 'admin/addHijriDate',
  deleteHijriDate: 'admin/deleteHijriDate',
  enableImsak: 'admin/enableImsak',
  updateVideoStatus: 'admin/updateVideoStatus',
  getDashboardData: 'admin/dashboard',
  getHijriCalender: 'common/getHirjiCalender',
  getAllSpecialDays: 'common/getAllSpecialDays',
  getProgram: 'common/getProgram',
  getBanner: 'admin/getBanner',
  addBanner: 'admin/addBanner',
  updateBanner: 'admin/updateBanner',
  deleteBanner: 'admin/deleteBanner',
  getFeedbackTypeList: 'admin/getFeedbackTypeList',
  addFeedbackType: 'admin/addFeedbackType',
  updateFeedbackType: 'admin/updateFeedbackType',
  deleteFeedbackType: 'admin/deleteFeedbackType',
  // Membership Pricing
  getMembershipPrices: 'membership/getMembershipPrices',
  saveMembershipPrice: 'membership/saveMembershipPrice',
  changeMembershipPriceStatus: 'membership/changeMembershipPriceStatus',
  getPurchaseMembershipList: 'membership/getPurchaseMembershipList',
}

export default EndPoints
